interface INativePromptBehaviors {
    cookieLengthSeconds?: number;
}

export class PromptNativeConfigDto {
    public behavior: INativePromptBehaviors;
}
